import { useTranslation } from "react-i18next";
import { MetadataCoverModel } from "../../../../models/workflow.model";
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { RemoveIcon } from "../../../../assets/icons";
import styles from "./Metadata.module.scss";

const Covers: React.FC<{ documents: MetadataCoverModel[]; onDelete?: (index: number) => void }> = ({
  documents,
  onDelete,
}) => {
  const { t } = useTranslation();

  return (
    <TableContainer className={styles.coversView}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className={styles.frontCoverFor}>{t("frontCoverFor")}</TableCell>
            <TableCell className={styles.fileName}>{t("fileName")}</TableCell>
            <TableCell className={styles.document}>{t("delete")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {documents.map((x, index) => (
            <TableRow key={`cover_view_id_${x.language}`}>
              <TableCell className={styles.frontCoverFor}>{x.coverFor}</TableCell>
              <TableCell className={styles.fileName}>{x.coverName}</TableCell>
              <TableCell className={styles.document}>
                {onDelete && (
                  <IconButton
                    onClick={() => {
                      onDelete(index);
                    }}
                  >
                    <RemoveIcon />
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Covers;
